export default __webpack_public_path__ + "static/media/2.5a086911.png";